module.exports = __webpack_public_path__ + "img/close.ca56dad2.png";